import {
  HISTORY_INCREMENT_ACTIVITY,
  HISTORY_INCREMENT_TRANSACTION,
} from './appHistoryActions';

const incrementBy = 6;

const appHistoryReducers = {
  [HISTORY_INCREMENT_ACTIVITY]: state => {
    return {
      ...state,
      activity: state.activity + incrementBy,
    };
  },
  [HISTORY_INCREMENT_TRANSACTION]: state => {
    return {
      ...state,
      transactions: state.transactions + incrementBy,
    };
  },
};

export default {
  name: 'appHistory',
  reducers: appHistoryReducers,
};
